<section class="theme-border side-menu-container">
    <div class="flex gap-2.5 items-center py-7 px-5 border-b theme-border">
        <img [src]="logo() || 'https://lepisode.team/assets/logo.svg'" />
        <p class="font-semibold theme-text text-lg">
            {{ title() }}
        </p>
    </div>
    <div class="flex flex-col gap-1 overflow-y-auto side-section">
        <ng-content />
    </div>
</section>
